import React, { useState } from 'react'
import { DialogTitle, Checkbox, FormControlLabel } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import DOMPurify from 'dompurify'
import { useTranslation } from 'react-i18next'
import { inject, observer } from 'mobx-react'
import { flow } from 'lodash'
import Dialog from '../DialogWrapper'

const PartnerConsentDialog = ({ dialog, mst_conversation }) => {
  const { t } = useTranslation()
  const [consented, setConsented] = useState(false)
  const { partnerConsentTitle, partnerConsentBody } = dialog?.data || {}

  const handleSubmit = (e) => {
    e.preventDefault()
    if (mst_conversation) {
      mst_conversation.setPartnerConcent(true)
    }
  }

  // partnerConsentBody is sanitized with DOMPurify before rendering
  const sanitizedBody = DOMPurify.sanitize(partnerConsentBody || '')

  return (
    <Dialog dialog={dialog} name='partnerConsent' type='thin'>
      <div>
        <DialogTitle disableTypography>{partnerConsentTitle}</DialogTitle>

        <section className='pane minimal-grey-pane big-top-padding big-bottom-padding'>
          <form onSubmit={handleSubmit}>
            <div className='row reg-bottom'>
              <div className='col-xs-12'>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={consented}
                      onChange={(e) => setConsented(e.target.checked)}
                      color='secondary'
                    />
                  }
                  label={
                    <div dangerouslySetInnerHTML={{ __html: sanitizedBody }} />
                  }
                />
              </div>
            </div>

            <div className='row center-xs fat-top'>
              <div className='col-xs-12'>
                <Button
                  type='submit'
                  className='reg-bottom flat-top btn-xl btn-block lowercase capitalize'
                  color='primary'
                  disabled={!consented}
                  variant='contained'
                >
                  {t('common.next')}
                </Button>
              </div>
            </div>
          </form>
        </section>
      </div>
    </Dialog>
  )
}

export default flow(
  observer,
  inject(({ mst: { conversations, dialogs: { closeDialog } } }, { dialog }) => {
    const conversationIdString = dialog?.data?.conversationId
    const conversationId = conversationIdString ? parseInt(conversationIdString) : null
    const mst_conversation = conversationId ? conversations.list.find((d) => d.id === conversationId) : null
    if (conversationId && !mst_conversation && !conversations.loadingIds.includes(conversationId)) {
      conversations.getConversation(conversationId)
    }
    return {
      mst_conversation,
      closeDialog: () => closeDialog('partnerConsent')
    }
  })
)(PartnerConsentDialog)
